import type { OfferVersionDto } from '@bqcrm/shared';
import { Text } from '@mantine/core';
import { formatDateTime } from '../../format';

/**
 * Stan prośby o wydanie z wyjątkiem (P3, Z-14 — bez osobnego statusu oferty): od kiedy i u kogo czeka,
 * poprzednia zgoda na wcześniejszą wersję i różnice rabatu, albo odrzucenie z komentarzem zatwierdzającego.
 */
export function IssueRequestInfo({ v, dimmed = false }: { v: OfferVersionDto; dimmed?: boolean }) {
  const r = v.issueRequest;
  const x = v.issueRejection;
  if (!r && !x) return null;
  if (!r && x) {
    return (
      <Text size="sm" mt={4} c="red.8">
        Prośbę o wyjątek z {formatDateTime(x.requestAt)} odrzucił(a) {x.byName ?? '—'} ({formatDateTime(x.at)}): „{x.comment}”. Popraw ofertę albo wyślij prośbę ponownie z wyjaśnieniem.
      </Text>
    );
  }
  const p = r!.previousApproval;
  return (
    <>
      <Text size="sm" mt={4} c={dimmed ? 'dimmed' : undefined}>
        <b>Czeka na zatwierdzenie wyjątku</b> — od {formatDateTime(r!.at)}
        {r!.byName ? ` (prosi: ${r!.byName})` : ''}, u: {r!.waitingFor ?? 'osoby z prawem zatwierdzania'}
        {r!.dueAt ? `, termin ${formatDateTime(r!.dueAt)}` : ''}
        {r!.note ? ` · „${r!.note}”` : ''}.
      </Text>
      {p && (
        <Text size="sm" mt={4} c={dimmed ? 'dimmed' : undefined}>
          Poprzednia zgoda: wersja {p.versionNo}
          {p.number ? ` (${p.number})` : ''}, {p.byName ?? '—'}, {formatDateTime(p.at)}
          {p.reason ? ` — „${p.reason}”` : ''}. {p.changes.length ? `Zmiany rabatu: ${p.changes.join('; ')}.` : 'Rabaty bez zmian.'}
          {p.notHigher ? ' Rabat nie wyższy niż przy poprzedniej zgodzie.' : ' Rabat wyższy niż przy poprzedniej zgodzie.'}
        </Text>
      )}
    </>
  );
}
